"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const models_1 = require("../../api/ecommerce/models");
const translation_1 = require("../../common/js/helper/translation");
const money_1 = require("../helper/money");
class ProductPrice extends react_1.default.Component {
    render() {
        const { product, priceOptions, onlyIndividualPrice } = this.props;
        const unitPrice = (0, money_1.formattedPriceFromProduct)(product, priceOptions);
        if (models_1.ZkpProductDataCustomerTypeEnum.CustomerDiscount !== product.extensions?.zkpProductData?.customerType) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                this.renderPriceLabel((0, translation_1.t)('product_page.price'), priceOptions),
                this.renderUnitPrice(unitPrice, priceOptions)));
        }
        const pricesIsEqual = this.isEqualPrices(product, priceOptions);
        const priceLabel = pricesIsEqual ? (0, translation_1.t)('product_page.price') : (0, translation_1.t)('product_page.your_price');
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderPriceLabel(priceLabel, priceOptions),
            !onlyIndividualPrice && !pricesIsEqual ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "znd-product-price__normal-price mr-1" },
                    "(",
                    this.listPrice(product, priceOptions),
                    ")"))) : null,
            this.renderUnitPrice(unitPrice, priceOptions)));
    }
    listPrice(product, priceOptions) {
        return (0, money_1.formattedPriceFromProduct)(product, {
            ...priceOptions,
            isIndividualPrice: false,
        });
    }
    isEqualPrices(product, priceOptions) {
        if (!!priceOptions) {
            priceOptions.quantity = 1;
        }
        return this.listPrice(product, priceOptions) === (0, money_1.formattedPriceFromProduct)(product, priceOptions);
    }
    renderUnitPrice(price, priceOptions) {
        return priceOptions?.isPricePerYear ? (0, translation_1.t)('product_list.price_per_year', { price: price }) : price;
    }
    renderPriceLabel(label, priceOptions) {
        if (!priceOptions?.showPriceLabel) {
            return '';
        }
        return react_1.default.createElement("p", { className: priceOptions.classNamePriceLabel }, label);
    }
}
exports.default = ProductPrice;
